import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { UncontrolledTooltip } from 'reactstrap';
import { RefundModal } from '../modals/RefundModal';
import {
  cancelRefundOrder,
  getRefundOrderData,
  refundOrder
} from '../../../../api/orders/orders';
import { ORDER_STATUSES, ORDER_TYPES } from '../../../../config/constants';
import { NOTIFICATION_ORDER_ACTIONS, NOTIFICATION_REFUND_MODAL } from '../../../../config/notifications';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { scrollToMessages } from '../../../../hooks/useScrollToMessages';

function RefundOrder(props) {
  const [ showRefundModal, setShowRefundModal ] = useState( false );
  const [ refundOrderData, setRefundOrderData ] = useState( null );
  const { order } = props;

  useEffect( () => {
    if (refundOrderData) {
      setShowRefundModal( true );
    }
  }, [ refundOrderData ] );

  const onClick = () => {
    getRefundOrderData( {
      orderId: order.id,
      notificationId: NOTIFICATION_ORDER_ACTIONS
    } ).then( response => {
      if (response) {
        setRefundOrderData( response.data );
      }
    } ).finally(() => {
      scrollToMessages();
    });
  }

  const confirmRefund = () => {
    refundOrder( {
      orderId: order.id,
      notificationId: NOTIFICATION_ORDER_ACTIONS
    } ).then( response => {
      setShowRefundModal( false );
      props.actionCallback( true );
    } ).finally( () => {
      scrollToMessages();
    } );
  }

  const cancelRefund = () => {
    cancelRefundOrder( {
      orderId: order.id,
      notificationId: NOTIFICATION_REFUND_MODAL
    } ).then(response => {
      if (response && response.status >= 200 && response.status < 300) {
        setShowRefundModal( false );
      }
    } ).finally(() => {
      scrollToMessages();
    });
  }

  if (order.status !== ORDER_STATUSES.PAID || order.type === ORDER_TYPES.DIRECT_ALLOCATION.value) {
    return null;
  }

  return ( <>
      <Link
        to="#"
        className="cursor-pointer px-2 mx-2 link-icon-color"
        id={`refund-invoice-icon-` + props.index}
        onClick={onClick}
      >
        <FontAwesomeIcon
          size="lg"
          className="cursor-pointer"
          pointerEvents="none"
          icon={faMoneyBill}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`refund-invoice-icon-${props.index}`}
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        <FormattedMessage
          id="messages.refund"/>
      </UncontrolledTooltip>

      {showRefundModal && <RefundModal
        refundOrderData={refundOrderData}
        showModal={showRefundModal}
        confirmRefund={confirmRefund}
        closeModal={cancelRefund}/>}
    </>
  );
};

export { RefundOrder }
